<template>
  <div
    class="rate-table-header__cell"
    v-bind:class="[orderClass, activeClass, tweaks]"
    v-on:click="updateSort()"
  >
    <span class="rate-table-header__copy">{{ title }}</span>
    <span class="icon --xxs">
      <svg
        class="rate-table-header__icon icon__glyph"
        width="7px"
        height="4px"
        viewBox="0 0 7 4"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill=""
          fill-rule="evenodd"
        >
          <g id="Icons" transform="translate(-134.000000, -43.000000)" fill="">
            <polygon
              id="caret-small-down"
              points="134.707107 43 134 43.6965437 137.353553 47 140.707107 43.6965437 140 43 137.358734 45.6018093"
            ></polygon>
          </g>
        </g>
      </svg>
    </span>
  </div>
</template>

<script>
import eventHub from '../bankrate-events/index'

// @DEPRECATED - Rewrite or clean up for any future use
export default {
  data: function() {
    return {
      active: '',
      ascending: true
    }
  },

  props: {
    title: {
      default: ''
    },

    field: {
      default: ''
    },

    defaultActive: {
      default: function() {
        return {}
      }
    },

    firstSort: {
      default: ''
    },

    tweaks: {
      default: ''
    }
  },

  created: function() {
    this.active = this.defaultActive
    eventHub.$on('sort::resetOthers', this.onResetEvent)
    eventHub.$on('sort::set', this.onSetEvent)
  },

  computed: {
    activeClass: function() {
      return this.field === this.active.field ? '--is-active' : ''
    },

    orderClass: function() {
      if (this.field === this.active.field) {
        return this.ascending ? '--is-ascending' : 'desc'
      }
      return ''
    }
  },

  methods: {
    /**
     *  Listen for reset event
     */
    onResetEvent: function(eventData) {
      if (eventData.name !== this.field) {
        // Other component is sorting. Reset ascending property
        this.ascending = true
      }
    },

    /**
     *  Listen for set event
     */
    onSetEvent: function(eventData) {
      if (eventData.name === this.field) {
        // This component is sorting
        this.ascending = eventData.ascending
      }
    },

    /**
     *  Triggered once this element is clicked
     */
    updateSort: function() {
      if (this.active.field !== this.field) {
        // Click on other sibling
        this.ascending = this.firstSort === 'asc'
      } else {
        // Click on this instance
        this.ascending = !this.ascending
      }

      this.active = {
        field: this.field,
        ascending: this.ascending
      }

      eventHub.$emit('sort::change', {
        name: this.field,
        data: this.active,
        default: this.firstSort === 'asc'
      })
      eventHub.$emit('sort::resetOthers', { name: this.field })
    }
  }
}
</script>
